const $ = window.jQuery;
const $window = window.$window || $(window);

const ArchiveFilter = {
	init() {
		var $module = $('.tombstones');
		if (!$module.length) return;

		const $tombstones = $('.tombstones');

		const FilterThis = this;


		$('.sort-select').on('change', function () {
			$tombstones.find('li').fadeOut(300);

			if ($(this).find('option:selected').val() === 'price-low-high') {
				FilterThis.sort_low_high($tombstones[0]);

				$tombstones.find('li').fadeIn(300);

				return;
			}
			if ($(this).find('option:selected').val() === 'price-high-low') {
				FilterThis.sort_high_low($tombstones[0]);

				$tombstones.find('li').fadeIn(300);

				return;
			}

			if ($(this).find('option:selected').val() === 'modell-low-high') {
				FilterThis.sort_low_high_modell($tombstones[0]);
				$tombstones.find('li').fadeIn(300);
				return;
			}
			if ($(this).find('option:selected').val() === 'modell-high-low') {
				FilterThis.sort_high_low_modell($tombstones[0]);
				$tombstones.find('li').fadeIn(300);
				return;
			}
			if ($(this).find('option:selected').val() === 'name-low-high') {
				FilterThis.sort_low_high_name($tombstones[0]);
				$tombstones.find('li').fadeIn(300);
				return;
			}
			if ($(this).find('option:selected').val() === 'name-high-low') {
				FilterThis.sort_high_low_name($tombstones[0]);
				$tombstones.find('li').fadeIn(300);
				return;
			}
		});

/* 		$('.sort-select').trigger('change') */
	},
	removeitems(elem) {
		elem.remove();
	},
	sort_low_high(geek_list) {
		console.log('soritng');
		// Declaring Variables
		var i, run, li, stop;

		// Taking content of list as input

		run = true;

		while (run) {
			run = false;
			li = geek_list.getElementsByTagName('LI');

			// Loop traversing through all the list items
			for (i = 0; i < li.length - 1; i++) {
				stop = false;
				if (
					+$(li[i]).find('.tombstone--item').attr('data-price') >
					+$(li[i + 1])
						.find('.tombstone--item')
						.attr('data-price')
				) {
					stop = true;
					break;
				}
			}

			/* If the current item is smaller than 
			   the next item then adding it after 
			   it using insertBefore() method */
			if (stop) {
				li[i].parentNode.insertBefore(li[i + 1], li[i]);

				run = true;
			}
		}
	},
	sort_low_high_name(geek_list) {
		console.log('soritng');
		// Declaring Variables
		var i, run, li, stop;

		// Taking content of list as input

		run = true;

		while (run) {
			run = false;
			li = geek_list.getElementsByTagName('li');

			// Loop traversing through all the list items
			for (i = 0; i < li.length - 1; i++) {
				stop = false;

				let first = $(li[i]).attr('data-name');
				let second = $(li[i + 1]).attr('data-name');

				if (first > second) {
					stop = true;
					break;
				}
			}

			/* If the current item is smaller than 
			   the next item then adding it after 
			   it using insertBefore() method */
			if (stop) {
				li[i].parentNode.insertBefore(li[i + 1], li[i]);

				run = true;
			}
		}
	},

	sort_high_low_name(geek_list) {
		console.log('soritng');
		// Declaring Variables
		var i, run, li, stop;

		// Taking content of list as input

		run = true;

		while (run) {
			run = false;
			li = geek_list.getElementsByTagName('LI');

			// Loop traversing through all the list items
			for (i = 0; i < li.length - 1; i++) {
				stop = false;

				let first = $(li[i]).attr('data-name');
				let second = $(li[i + 1]).attr('data-name');
				console.log(first, second);
				if (
					first <
					second
				) {
					stop = true;
					break;
				}
			}

			/* If the current item is smaller than 
			   the next item then adding it after 
			   it using insertBefore() method */
			if (stop) {
				li[i].parentNode.insertBefore(li[i + 1], li[i]);

				run = true;
			}
		}
	},
	sort_low_high_modell(geek_list) {
		console.log('soritng');
		// Declaring Variables
		var i, run, li, stop;

		// Taking content of list as input

		run = true;

		while (run) {
			run = false;
			li = geek_list.getElementsByTagName('li');

			// Loop traversing through all the list items
			for (i = 0; i < li.length - 1; i++) {
				stop = false;

				let first = $(li[i]).attr('data-modell');
				let second = $(li[i + 1]).attr('data-modell');

				if (+first > +second) {
					stop = true;
					break;
				}
			}

			/* If the current item is smaller than 
			   the next item then adding it after 
			   it using insertBefore() method */
			if (stop) {
				li[i].parentNode.insertBefore(li[i + 1], li[i]);

				run = true;
			}
		}
	},
	
	sort_high_low_modell(geek_list) {
		console.log('soritng');
		// Declaring Variables
		var i, run, li, stop;

		// Taking content of list as input

		run = true;

		while (run) {
			run = false;
			li = geek_list.getElementsByTagName('LI');

			// Loop traversing through all the list items
			for (i = 0; i < li.length - 1; i++) {
				stop = false;

				let first = $(li[i]).attr('data-modell');
				let second = $(li[i + 1]).attr('data-modell');
				console.log(first, second);
				if (
					+first <
					+second
				) {
					stop = true;
					break;
				}
			}

			/* If the current item is smaller than 
			   the next item then adding it after 
			   it using insertBefore() method */
			if (stop) {
				li[i].parentNode.insertBefore(li[i + 1], li[i]);

				run = true;
			}
		}
	},
	sort_high_low(geek_list) {
		console.log('soritng');
		// Declaring Variables
		var i, run, li, stop;

		// Taking content of list as input

		run = true;

		while (run) {
			run = false;
			li = geek_list.getElementsByTagName('LI');

			// Loop traversing through all the list items
			for (i = 0; i < li.length - 1; i++) {
				stop = false;
				if (
					+$(li[i]).find('.tombstone--item').attr('data-price') <
					+$(li[i + 1])
						.find('.tombstone--item')
						.attr('data-price')
				) {
					stop = true;
					break;
				}
			}

			/* If the current item is smaller than 
			   the next item then adding it after 
			   it using insertBefore() method */
			if (stop) {
				li[i].parentNode.insertBefore(li[i + 1], li[i]);

				run = true;
			}
		}
	},
};

export default ArchiveFilter;
